<template>
    <div v-loading="dataLoading">
        <el-form
            v-if="data && formData"
            :model="formData"
            ref="formData"
            label-position="top"
        >
            <div class="group">                
                <el-card shadow="never" class="MT20">
					<div slot="header" class="clearfix">
					    <span>基本信息</span>
					</div>
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12">
                            <el-row>
                                <el-col><span class="color-info">订单状态: </span>{{orderStatus.get(data.orderStatus)}}</el-col>
                                <el-col class="MT10"><span class="color-info">订单编号: </span>{{data.orderSn}}</el-col>
                                <el-col v-if="data.paymentStatus" class="MT10"><span class="color-info">支付状态: </span>{{data.paymentStatus == 1  ? '未支付' : '已支付'}}</el-col>
                                <el-col class="MT10"><span class="color-info">下单终端: </span>{{data.terminal}}</el-col>
                                <el-col v-if="data.payment" class="MT10"><span class="color-info">支付方式: </span>{{data.payment}}</el-col>
                                <el-col v-if="data.paymentNo" class="MT10"><span class="color-info">支付号: </span>{{data.paymentNo}}</el-col>
                                <el-col v-if="data.paymentThreeNo" class="MT10"><span class="color-info">流水号: </span>{{data.paymentThreeNo}}</el-col>
								<el-col class="MT10"><span class="color-info">订单备注: </span>{{data.customerRemark}}</el-col>
                            </el-row>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-steps direction="vertical">
                                <el-step v-if="data.cancelTime" icon="el-icon-circle-close" status="finish" title="取消" :description="data.cancelTime"></el-step>
                                <el-step v-if="data.refundDate" icon="el-icon-money" status="finish" title="退款" :description="data.refundDate"></el-step>
                                <el-step v-if="data.receiptTime" icon="el-icon-box" status="finish" title="收货" :description="data.receiptTime"></el-step> 
                                <el-step v-if="data.pickup !='现场自取'" :status="data.deliverDate ? 'finish' : ''" icon="el-icon-truck" title="发货" :description="data.deliverDate ? data.deliverDate : '未发货'"></el-step>
                                
                                <el-step v-if="data.pickup =='现场自取'" :status="data.pickupDate ? 'finish' : ''" icon="el-icon-truck" title="签收" :description="data.pickupDate ? data.pickupDate : '未签收'"></el-step>
                                
                                <el-step :status="data.payDate ? 'finish' : ''" icon="el-icon-bank-card" title="支付" :description="data.payDate ? data.payDate : '未支付'"></el-step>
                                <el-step status="finish" icon="el-icon-tickets" title="下单" :description="data.createTime"></el-step>
                            </el-steps>
                            <div v-if="data.refundDate" class="color-info">{{data.refundDate}} 产生退款</div>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="group MT20">                
                <el-card shadow="never" class="MT20">
					<div slot="header" class="clearfix">
					    <span>消费信息</span>
					</div>
                    <el-row :gutter="40">
                        <el-col :span="8"><span class="color-info">订单总额: </span>￥{{data.payableAmount}}</el-col>
                        <el-col :span="8"><span class="color-info">商品总额: </span>￥{{data.totalAmount}}</el-col>
                        <el-col :span="8"><span class="color-info">运费: </span>￥{{data.freight}}</el-col>
                        <el-col :span="8"><span class="color-info">实付金额: </span>￥{{data.amountpaid}}</el-col>
                        <el-col :span="8"><span class="color-info">优惠券: </span>￥{{data.totalDiscountAmount}}</el-col>
						<el-col :span="8"><span class="color-info">有效商品数: </span>{{data.validGoodsNum}}</el-col>
                    </el-row>

                    <div v-for="(item,index) in data.goodsOrderDetails" :key="index">
                        <el-divider></el-divider>
                        <div class="page-group-title font16"><span>{{item.name}} <span class="color-info">{{item.skuDesc}}</span></span></div>
                        <el-row :gutter="40">
                            <el-col :span="8"><span class="color-info">商品ID: </span>{{item.goodsId}}</el-col>
                            <el-col :span="8"><span class="color-info">单价: </span>￥{{item.price}}</el-col>
                            <el-col :span="8"><span class="color-info">数量: </span>{{item.num}}</el-col>
                        </el-row>
                        <el-row :gutter="40">
                            <el-col :span="8"><span class="color-info">总额: </span>{{item.totalAmount}}</el-col>
                            <el-col :span="8"><span class="color-info">待退款数: </span>{{item.pendingRefundNum}}</el-col>
                            <el-col :span="8"><span class="color-info">已退款数量: </span>{{item.refundedNum}}</el-col>
                        </el-row>
                        <el-row v-if="item.expressId" :gutter="40">
                            <el-col :span="8"><span class="color-info">快递公司: </span>{{item.expressId}}</el-col>
                            <el-col v-if="item.expressNo" :span="8"><span class="color-info">运单号: </span>{{item.expressNo}}</el-col>
                            <el-col v-if="item.expressTime" :span="8"><span class="color-info">发货时间: </span>{{item.expressTime}}</el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="group MT20">                
                <el-card shadow="never" class="MT20">
					<div slot="header" class="clearfix">
					    <span>用户信息
							<el-button v-if="$utils.have('/goodOrder/saveOrderAddr')" type="primary" plain size="mini" @click="handleEditAddress()" class="fr">修改收货信息</el-button>
					    </span>
					</div>
                    <el-row :gutter="40">
                        <el-col :span="8"><span class="color-info">用户ID: </span>{{data.userId}}</el-col>
                        <el-col :span="8"><span class="color-info">用户昵称: </span>{{data.userName}}</el-col>
                       <el-col :span="8"><span class="color-info">下单手机号: </span>{{data.telephone}}</el-col>
                        <el-col :span="8"><span class="color-info">取货方式: </span>{{data.pickup}}</el-col>
						<el-col :span="8"><span class="color-info">收货人姓名: </span>{{data.receiptName}}</el-col>
						<el-col :span="8"><span class="color-info">收货人联系手机: </span>{{data.areaCode}} {{data.receipetTel}} </el-col>
						<el-col :span="8"><span class="color-info">收货省市: </span>{{data.provinceName}} / {{data.cityName}}</el-col>
						<el-col :span="8"><span class="color-info">收货地址: </span>{{data.address}}</el-col>
                        <!-- <el-col v-if="data.expressName" :span="8"><span class="color-info">快递公司: </span>{{data.expressName}}</el-col>
                        <el-col v-if="data.expressNo" :span="8"><span class="color-info">运单号: </span>{{data.expressNo}}</el-col> -->
                    </el-row>
                    <!-- <el-divider></el-divider>
                    <el-row :gutter="40">
                        <el-col v-if="data && data.goodsOrderDetails[0].skuType == 4" :xs="24" :sm="12" :xl="8">
                            <el-form-item prop="customerName" label="收货人姓名:" :rules="[{required: true, message: '请输入收货人姓名'}]">
                                <el-input v-model.trim="formData.customerName" placeholder="请输入收货人姓名" maxlength="20" size="medium"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :xl="8">
                            <el-form-item prop="telephone" label="联系手机:" :rules="[{required: true, message: '请输入联系手机'}]">
                                <el-input class="input-with-select" v-model.trim="formData.telephone" placeholder="请输入联系手机" maxlength="20" size="medium">
                                    <el-select v-model="formData.areaCode" slot="prepend" placeholder="请选择区号">
                                        <el-option v-for="(item,index) in countryList" :key="index" :label="`+${item.code}`" :value="item.codeView">
                                            +{{item.code}} {{item.name}}
                                        </el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <template v-if="data && data.goodsOrderDetails[0].skuType == 4">
                            <el-col :xs="24" :sm="12" :xl="8">
                                <el-form-item prop="city" label="收货省市:" :rules="[{required: true, message: '请选择收货省份城市'}]">
                                    <el-cascader
                                        v-model="formData.city"
                                        :options="cityList"
                                        filterable
                                        :props="{label:'name',children:'cityList',value:'name'}"
                                        size="medium"
                                        style="width:100%"
                                        ref="cityCascader"
                                        @change="changeCity">
                                    </el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :xl="8">
                                <el-form-item prop="address" label="收货地址:" :rules="[{required: true, message: '请输入收货地址'}]">
                                    <el-input v-model.trim="formData.address" placeholder="请输入收货地址" maxlength="100" size="medium"></el-input>
                                </el-form-item>
                            </el-col>
                        </template>
                    </el-row> -->
                </el-card>
            </div>
            <div class="group MT20">
				<el-card shadow="never" class="MT20">
					<div slot="header" class="clearfix">
					    <span>订单备注</span>
					</div>
					<div class="MT20">
					    <el-form-item prop="systemRemark">
					        <el-input v-model="formData.systemRemark" type="textarea" :rows="4" maxlength="200" show-word-limit></el-input>
					    </el-form-item>
					</div>
				</el-card>                
            </div>
            <div class="group MT20">
                <el-button @click="goBack">返回</el-button>
                <el-button
                    v-if="$utils.have('/goodOrder/save')"
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >保存</el-button
                >
            </div>
        </el-form>
		<OrderAddressEdit  ref="orderAddressEdit" @onUpdate="getDataDetail"></OrderAddressEdit>
    </div>
</template>

<script>
import {fetchAllCity,fetchAllCountry} from '@/assets/js/commonApi';
import OrderAddressEdit from './components/orderAddressEdit';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
	components:{OrderAddressEdit},
    data(){
        return{
            dataLoading: false,
            redirect: this.$route.query.redirect || '/goods/order/list',
            data:null,
            formData:null,
            btnLoading: false,
            cityList:[],//所有省份城市集合
            countryList:[],//所有国家集合
        }
    },
    computed:{
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'已发货'],
                [5,'已完成'],
                [6,'已过期'],
                [7,'已取消'],
            ])
        }
    },
    created(){
        if (this.id) {
            this.getDataDetail();
        }
        this.getCityList();
        this.getCountryList();
    },
    methods:{
		//修改收货信息
		handleEditAddress(){
		    this.$refs.orderAddressEdit.show(this.data);
		},
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
        //获取所有国家（区号）
        async getCountryList(){
            const res = await fetchAllCountry({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.countryList = result;
            }
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/goodOrder/detail",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = {...result};
                        this.formData = {
                            customerName: result.receiptName || '',
                            areaCode:result.areaCode || '86_CN',
                            // telephone: result.receipetTel || '',
                            address: result.address || '',
                            // expressId:result.expressId || '',
                            // expressNo:result.expressNo || '',
                            provinceName: result.provinceName || '北京',
                            cityName: result.cityName || '北京',
                            orderId: result.orderId,
                            city: [result.provinceName || '北京',result.cityName || '北京'],
                            systemRemark: result.systemRemark || '',
                        }
                    } else {
                        this.$message.error(msg || "获取订单详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取订单详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //选择城市
        changeCity(value){
            this.formData.provinceName = value ? value[0] : '';
            this.formData.cityName = value ? value[1] : '';
        },
        onSubmit(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/goodOrder/save",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
         //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
    }
}
.page-group-title.font16 span{
    font-size: 16px;
}
</style>